import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { getGridIsOpened } from 'reducers/UI/gridDisplay';
import { getUISetting } from 'reducers/configs/settings';
import { useBreakpoints } from 'utils/hooks/UI';
import CustomerDisplaySimulator from 'containers/CustomerDisplaySimulator/CustomerDisplaySimulator';
import ModalPage from 'containers/ModalPage/ModalPage';
import './POS.scss';
import { autoImportLazyComponents } from 'constants/modalPage';
import Col1 from 'containers/Col1/Col1';
import Col2 from 'containers/Col2';
import { Grid } from '@material-ui/core';

const POS = () => {
  const largeView = useBreakpoints().mdplus;
  const isQuickView = useSelector(getGridIsOpened);
  const isFullScreen = useSelector(getUISetting('isFullScreen'));
  const isEvenColumns = useSelector(getUISetting('isEvenColumns')) && largeView;

  useEffect(() => autoImportLazyComponents(true), []);

  return (
    <Grid
      container
      className={classNames('pos-container', {
        quickView: isQuickView,
        fullScreen: isFullScreen,
      })}
    >
      <Grid
        item
        xs={12}
        md={12}
        lg="auto"
        id="pos-col-1"
        className={classNames('pos-col-1', {
          narrow: largeView,
          even: isEvenColumns,
        })}
      >
        <Col1 />
      </Grid>
      <Grid item className="pos-col-2">
        <div style={{ display: largeView ? 'initial' : 'none' }}>
          <Col2 />
        </div>
        <div>
          <ModalPage />
        </div>
      </Grid>
      {localStorage.getItem('Debug: mockCustomerDisplay') && (
        <CustomerDisplaySimulator />
      )}
    </Grid>
  );
};

export default POS;
